<script lang="ts">
  import DynamicCanvas from "./DynamicCanvas.svelte"
  import { Scene, SceneNode } from "../api/scene"

  export let canvasWidth:number
  export let canvasHeight:number
  export let sceneNode:SceneNode | null

  let scene:Scene

  $ : {
    if (scene) {
      scene.clear()
      if (sceneNode) {
        scene.add(sceneNode)
      }
    }
  }

  function handleCanvas(childCanvas:HTMLCanvasElement) {
    scene = new Scene(childCanvas)
  }

  function handleRender(ctx:CanvasRenderingContext2D) {
    scene?.render(ctx)
  }

</script>

<DynamicCanvas onCanvas={handleCanvas} onRender={handleRender} canvasWidth={canvasWidth} canvasHeight={canvasHeight}></DynamicCanvas>